import React               from 'react';
import QuoteTips           from 'pu-react/components/QuoteTips';
import EmailQuoteValidates from 'pu-react/components/EmailQuoteValidates';
import PriceMatrix         from './price/PriceMatrix';
import FinishThicknessTip  from './price/FinishThicknessTip';
import QuoteTipList        from '../data/QuoteTips';

export default props => (
  <div className="pcb-price-section">
    <div className="price-matrices">
      <div className="price-matrix">
        <div className="text-end mb-3">
          <EmailQuoteValidates {...props} />
        </div>
        <PriceMatrix {...props} />
      </div>
    </div>
    <div>
      <QuoteTips list={QuoteTipList} >
        <FinishThicknessTip {...props} />
      </QuoteTips>
    </div>
  </div>
);
